import { createAction } from '../util/index.js';

export const displaySubmitButtonQrf = createAction(
  'DISPLAY_SUBMIT_BUTTON_QRF',
  requestObject => requestObject
);
export const displayClearButtonQrf = createAction('DISPLAY_CLEAR_BUTTON_QRF', requestObject => requestObject);
export const clearFormValueQRF = createAction('CLEAR_FORM_VALUE_QRF', requestObject => requestObject);
export const attachmentQrf = createAction('ATTACHMENT_QRF', requestObject => requestObject);
export const updateGuideYes = createAction('UPDATE_GUIDE_YES', requestObject => requestObject);
export const updateGuideNo = createAction('UPDATE_GUIDE_NO', requestObject => requestObject);
export const updateFutureProductYes = createAction('UPDATE_FUT_PRODUCT', requestObject => requestObject);
export const updateDisgardTrf = createAction('UPDATE_DISGARD_TRF', requestObject => requestObject);
export const updateProposedCorrectiveAction = createAction(
  'UPDATE_PROPOSED_CORRECTIVE_ACTION',
  requestObject => requestObject
);